import Searchbar from "../../Helpers/Searchbar/Searchbar";
import trans from "../../../utils";
import { InputSelect } from "../../Helpers/Input/RefactoredInput";
import { useGetAllConfigurationsQuery } from "../../../Redux/service/Configuration/Configuration";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

export default function ConstructionRequestHead({
	setFilter,
	query,
	handleQueryChange,
	children,
	filter,
	configFilter,
	setConfigFilter,
}) {
	const inf = useSelector((state) => state.users.user);
	const [options, setOptions] = useState(null);
	const typeOptions = [
		{ label: trans("Inspection Request"), value: "IR" },
		{ label: trans("Snag"), value: "Snag" },
	];
	const qaOptions = [
		{ label: trans("Inspection Request"), value: "IRQA" },
		{ label: trans("Snag"), value: "SnagQA" },
	];
	const { data } = useGetAllConfigurationsQuery({ page: 1, limit: 100000 });
	useEffect(() => {
		if (
			inf?.attributes?.role === "qa" ||
			inf?.attributes?.role === "consultant"
		) {
			setOptions(qaOptions);
			setFilter("IRQA");
		} else if (inf?.attributes?.role === "contractor") {
			setOptions(typeOptions);
			setFilter("IR");
		}
	}, []);

	return (
		<>
			<div className="bg-white p-16 d-flex align-items-baseline gap-3">
				<Searchbar
					// eslint-disable-next-line react/style-prop-object
					style="search search-dark input-group"
					path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
					placeholder={trans("Search")}
					value={query}
					onChange={handleQueryChange}
				/>
				<InputSelect
					placeholder={trans("Type")}
					options={options}
					formstyle="text-capitalize flex-grow-1"
					onChange={(e) => {
						setFilter(e);
					}}
					value={filter}
				/>
				<InputSelect
					placeholder={trans("Select Configuration")}
					options={data?.data?.map((i) => {
						return { label: i.name, value: i.name };
					})}
					formstyle="text-capitalize flex-grow-1"
					onChange={(e) => {
						setConfigFilter(e);
					}}
					value={configFilter}
					allowClear
				/>
				{children}
			</div>
		</>
	);
}
